/* eslint-disable react/destructuring-assignment */
import React, { Component } from '@ali/odin/react';
import styles from './markdown.less';
import marked from 'marked';

marked.setOptions({
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: true,
})

class Markdown extends Component<{
  markdown: string;
  title: string;
  onChange: (obj: any) => void;
}, {
  html: string;
  menu: (onClick?: (e?: React.MouseEvent<HTMLLIElement, MouseEvent>, index?: number) => void) => JSX.Element | null;
}> {
  constructor(props) {
    super(props);
    this.state = {
      html: '',
      menu: () => null
    }
  }
  componentDidMount() {
    const { markdown, onChange } = this.props;
    const { html, menu } = this.getMenu(marked(markdown));
    this.setState({
      html, menu
    }, () => {
      onChange({
        html, menu
      })
    });
  }

  render(){
    const { title } = this.props;
    const { html, menu } = this.state;
    return <div className={styles.markdownBox}>
      <div
        className={styles.markdownMenu}
      >
        <h4>{title}</h4>
        {menu()}
      </div>
      <div
        className={`${styles.markdownBody} ${styles.markdownContent}`}
      >
        <div className={styles.markdownBodyContainer} dangerouslySetInnerHTML={{__html: html}}></div>
      </div>
    </div>
  }

  getMenu(buffStr) {
    let arr, before, html, key, menuArr, reId, regex, title;
    html = buffStr;
    regex = /(<h[1-6])[^>]*?>/ig;
    html = html.replace(regex, "$1>");
    arr = html.split('\n');
    before = [];
    menuArr = [];
    for (key in arr) {
      title = arr[key].match(/^(\<h[1-6]\>[\s\S][^<\/]*\<\/h[1-6]\>)/g);
      if (title !== null) {
        before.push(title[0]);
      }
    }
    for (key in before) {
      if (before[key].indexOf('h1') !== -1) {
        reId = before[key].replace('h1', 'h1 id="menu-' + key + '"');
        html = html.replace(before[key], reId);
        menuArr.push([1, before[key].match(/^\<h[1-6]\>([\s\S][^<\/]*)\<\/h[1-6]\>/)[1]]);
      } else if (before[key].indexOf('h2') !== -1) {
        reId = before[key].replace('h2', 'h2 id="menu-' + key + '"');
        html = html.replace(before[key], reId);
        menuArr.push([2, before[key].match(/^\<h[1-6]\>([\s\S][^<\/]*)\<\/h[1-6]\>/)[1]]);
      } else if (before[key].indexOf('h3') !== -1) {
        reId = before[key].replace('h3', 'h3 id="menu-' + key + '"');
        html = html.replace(before[key], reId);
        menuArr.push([3, before[key].match(/^\<h[1-6]\>([\s\S][^<\/]*)\<\/h[1-6]\>/)[1]]);
      } else if (before[key].indexOf('h4') !== -1) {
        reId = before[key].replace('h4', 'h4 id="menu-' + key + '"');
        html = html.replace(before[key], reId);
        menuArr.push([4, before[key].match(/^\<h[1-6]\>([\s\S][^<\/]*)\<\/h[1-6]\>/)[1]]);
      } else if (before[key].indexOf('h5') !== -1) {
        reId = before[key].replace('h5', 'h5 id="menu-' + key + '"');
        html = html.replace(before[key], reId);
        menuArr.push([5, before[key].match(/^\<h[1-6]\>([\s\S][^<\/]*)\<\/h[1-6]\>/)[1]]);
      } else if (before[key].indexOf('h6') !== -1) {
        reId = before[key].replace('h6', 'h6 id="menu-' + key + '"');
        html = html.replace(before[key], reId);
        menuArr.push([6, before[key].match(/^\<h[1-6]\>([\s\S][^<\/]*)\<\/h[1-6]\>/)[1]]);
      }
    }
    let menu = function(onClick?: (e?: React.MouseEvent<HTMLLIElement, MouseEvent>, index?: number) => void) {
      return (<ul>
        {
          menuArr.map((item, index) => <li key={index} className={`menu-index-${item[0]}`} onClick={e => {
            onClick && onClick(e, index)
          }}>
            <a href={`#menu-${index}`}>{item[1]}</a>
          </li>)
        }
      </ul>)
    }
    return {
      html,
      menu
    }
  }
}

export default Markdown;
